"use client";

import { signIn } from "next-auth/react";
import { Button } from "@/components/shadcn/button";
import { ArrowRight, Heart, CheckCircle2 } from "lucide-react";

export function HeroSection() {
  const handleStartReferral = () =>
    signIn("keycloak", { callbackUrl: "/api/auth/post-signin" }, { prompt: "create" });

  return (
    <section className="relative z-10 mx-auto w-full max-w-7xl px-4 sm:px-6 py-12 sm:py-16 lg:py-24">
      <div className="text-center">
        <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-emerald-200 bg-emerald-50/80 px-5 py-2.5 text-sm font-medium text-emerald-700 shadow-sm backdrop-blur-sm">
          <Heart className="h-4 w-4 flex-shrink-0" />
          Free, Confidential Support for Your Child's Development
        </div>

        <h1 className="mx-auto mb-6 max-w-4xl text-4xl font-bold leading-tight tracking-tight text-gray-900 sm:text-5xl md:text-6xl lg:text-7xl">
          Is your child meeting their{" "}
          <span className="bg-gradient-to-r from-emerald-600 to-teal-600 bg-clip-text text-transparent">
            developmental milestones?
          </span>
        </h1>

        <p className="mx-auto mb-4 max-w-3xl text-lg leading-relaxed text-gray-700 sm:text-xl md:text-2xl">
          Early Intervention services can help children from birth to age 3 reach their full potential.
        </p>

        <p className="mx-auto mb-10 max-w-2xl text-base text-gray-600 sm:text-lg">
          If you have concerns about your child's speech, movement, learning, or behavior, we're here to help. Making a referral is free, confidential, and the first step toward support.
        </p>

        <div className="flex flex-col items-center justify-center gap-4 sm:flex-row">
          <Button
            size="lg"
            className="w-full sm:w-auto h-16 bg-gradient-to-r from-emerald-600 to-teal-600 px-10 text-lg font-semibold shadow-xl shadow-emerald-500/30 transition-all hover:shadow-2xl hover:shadow-emerald-500/40"
            onClick={handleStartReferral}
          >
            Start a Referral
            <ArrowRight className="ml-2 h-6 w-6" />
          </Button>
          <Button
            size="lg"
            variant="outline"
            className="w-full sm:w-auto h-16 border-2 px-10 text-lg font-semibold backdrop-blur-sm"
            onClick={() => {
              document.getElementById("when-to-refer")?.scrollIntoView({ behavior: "smooth" });
            }}
          >
            Learn More
          </Button>
        </div>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-4 sm:gap-6 md:gap-8 text-sm text-gray-600">
          <div className="flex items-center gap-2">
            <CheckCircle2 className="h-5 w-5 text-emerald-600" />
            <span>Free services</span>
          </div>
          <div className="flex items-center gap-2">
            <CheckCircle2 className="h-5 w-5 text-emerald-600" />
            <span>Confidential</span>
          </div>
          <div className="flex items-center gap-2">
            <CheckCircle2 className="h-5 w-5 text-emerald-600" />
            <span>No wait for evaluation</span>
          </div>
        </div>
      </div>
    </section>
  );
}